export const pages = {
	'linkOutMDE': { id: 'linkOutMDE', page: 'text', getter: () => import(/* webpackChunkName: 'text' */ 'components/bolt/text/text') }
};
export const sections = [

];
